import React from "react";
import { useTranslation } from "react-i18next";
import { Plug } from "lucide-react";
import DynamicsConnectionCard from "../../components/integrations/DynamicsConnectionCard";
import OliverConnectionCard from "../../components/integrations/OliverConnectionCard";

const IntegrationsPage: React.FC = () => {
  const { t } = useTranslation("orders");

  return (
    <div className="max-w-4xl mx-auto p-4 md:p-6 space-y-4">
      <div className="flex items-center gap-3">
        <Plug className="h-6 w-6 text-[#C97A3C]" />
        <div>
          <h1 className="text-xl font-medium text-[#0B0F0E]">
            {t("integrations.title")}
          </h1>
          <p className="text-[13px] text-[#8A9590]">
            {t("integrations.subtitle")}
          </p>
        </div>
      </div>

      <DynamicsConnectionCard />
      <OliverConnectionCard />
    </div>
  );
};

export default IntegrationsPage;
